import {
  GetProjectResponse,
  GetProjectTicketsResponse,
} from "../../services/project";

export type ProjectDetailPageState = {
  projectTickets: GetProjectTicketsResponse;
  projects: GetProjectResponse;
  ifSpreadSheet: {
    tmplateRow: IfSpreadsheetRecordData;
  };
  cpntSpreadSheet: {
    tmplateRow: CnptSpreadsheetRecordData;
  };
};

export type IfSpreadsheetState = {
  results: IfSpreadsheetRecordData[];
  codes?: {};
};

export type IfSpreadsheetRecordData = {
  tag: string;
  stgDplymntPlnDate: string;
  prdDplymntPlnDate: string;
  total: string;
  stsDsgnDesigning: string;
  stsDsgnReviewing: string;
  stsStgDplymntPlanning: string;
  stsStgDplymntPlanningBlocked: string;
  stsStgDplymntAwaitingApproval: string;
  stsStgDplymntPlanned: string;
  stsPrdDplymntPlanning: string;
  stsPrdDplymntPlanningBlocked: string;
  stsPrdDplymntAwaitingApproval: string;
  stsPrdDplymntPlanned: string;
  stsCompleted: string;
};

export type CnptSpreadsheetState = {
  results: CnptSpreadsheetRecordData[];
  codes?: {};
};

export type CnptSpreadsheetRecordData = {
  pjtId: string;
  pjtName: string;
  stgSchedDplymntDate: string;
  prdSchedDplymntDate: string;
  dipByRgn: string;
  cpntId: string;
  cpntPjtTypeName: string;
  inOutTypeName: string;
  prtcolTypeName: string;
  reqTskSlctdFlg: string;
  stgIfdDplymntPsblFlg: string;
  prdIfdDplymntPsblFlg: string;
  completedFlg: string;
};

export type SpreadsheetMessage = {
  messageId: string;
  message: string;
  column: string;
};

export type PageNewState =
  | ProjectDetailPageState
  | ((prevState: ProjectDetailPageState) => ProjectDetailPageState);
